import { Box, Stack } from '@mui/material'
import LactationLogo from 'assets/LactationLogo'
import { useWidgetMilkingDeviationList } from 'components/farm-dashboard/hooks/useWidgetMilkingDeviationList'
import { useAppSelector } from 'store/hooks'
import { COLORS } from 'styles/colors'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary14 } from 'ui/typography/TypographySecondary14'
import { BaseWidget } from '../baseWidget'

export const MilkingDeviationsWidget = () => {
	const { permissions } = useAppSelector(state => state.authReducer)
	const { data, isLoading, error } = useWidgetMilkingDeviationList()

	if (!permissions?.license_milking_process_check || error) return null

	const deviationsCount = data?.count ?? null

	return (
		<BaseWidget
			icon={
				<Box
					sx={{
						width: '24px',
						height: '24px',
						backgroundColor: COLORS.blueBg,
						borderRadius: '50%',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
					}}
				>
					<LactationLogo color={COLORS.blue} width={16} height={12} />
				</Box>
			}
			path={'/milking-process'}
			isLoading={isLoading}
		>
			<Stack direction='column' gap='8px'>
				<Stack direction='row' gap='4px' alignItems='center'>
					{deviationsCount === null ? (
						<TypographySecondary14>Нет данных</TypographySecondary14>
					) : (
						(deviationsCount || deviationsCount === 0) && (
							<TypographyPrimary16Bold
								sx={{
									color: deviationsCount !== 0 ? COLORS.error : COLORS.black,
								}}
							>
								{deviationsCount.toLocaleString()}
							</TypographyPrimary16Bold>
						)
					)}
				</Stack>
				<TypographyPrimary>Отклонений в рутине доения</TypographyPrimary>
			</Stack>
		</BaseWidget>
	)
}
